import React, { useRef } from 'react';
import { useField } from 'formik';
import { useErrorText } from '../hooks/useErrorText';
import { TextInputTWProps } from './TextInputTW';
import { useAutoFocus } from '../hooks/useAutoFocus';
import classNames from 'classnames';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';
import { MobilityHeaderFormCell } from '../formCellTW/MobilityHeaderFormCell';

export interface MobilityHeaderTextFieldProps extends TextInputTWProps {
  name: string;
  isInlineLabel?: boolean;
  inputClassName?: string;
  labelClassName?: string;
  showErrorText?: boolean;
}

export const MobilityHeaderTextField: React.FC<MobilityHeaderTextFieldProps> = ({ name, onChange, ...rest }) => {
  const [fieldInputProps, fieldMetaProps] = useField<string>(name);

  const errorText = useErrorText<string>(fieldMetaProps);

  const textInputRef = useRef<HTMLInputElement>(null);

  useAutoFocus(!!rest.autoFocus, textInputRef);

  return (
    <MobilityHeaderFormCell
      disabled={rest.disabled}
      labelText={rest.labelText}
      errorText={errorText}
      isRequired={rest.isRequired}
      hintText={rest.hintText}
      name={name}
      className={rest.className}
      isInlineLabel={rest.isInlineLabel}
      labelClassName={rest.labelClassName}
      showErrorText={rest.showErrorText}
    >
      <input
        type={'text'}
        disabled={rest.disabled}
        id={name}
        className={classNames(
          rest.inputClassName,
          'block rounded-md border-0 ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-inset',
          {
            'text-red-900 placeholder:text-red-300 focus:ring-red-600': !!errorText,
            'text-gray-900 placeholder:text-text-content-placeholder focus:ring-foundation-primary': !errorText,
          }
        )}
        placeholder={rest.placeholder}
        onFocus={rest.onFocus}
        readOnly={rest.readOnly}
        ref={textInputRef}
        autoComplete={'off'}
        data-test-id={mergeTests(rest['data-test-id'], 'input-text-tailwind')}
        {...fieldInputProps}
      />
    </MobilityHeaderFormCell>
  );
};
